<template>
  <div class="stat-card">
    <span class="stat-card__label">Produção Total</span>
    <span class="stat-card__value">{{total_production || 0}}</span>
  </div>
</template>

<script>
export default {
  name:"Presentation",
  props:{
    total_production:Number
  }
}
</script>